export function Atmosphere({ variant = 'both' }: { variant?: 'cyan' | 'pink' | 'both' }) {
  return (
    <div className={`atmosphere atmosphere-${variant}`} aria-hidden="true">
      {variant !== 'pink' && <span className="blur blur-cyan" />}
      {variant !== 'cyan' && <span className="blur blur-pink" />}
    </div>
  );
}
